import SEO from "@/components/common/SEO";
import LegalLayout from "./LegalLayout";

import {
  organizationSchema,
  breadcrumbSchema,
} from "../../components/common/schema";

const schemas = [
  organizationSchema(),

  breadcrumbSchema([
    {
      name: "Home",
      path: "/",
    },
    {
      name: "Cookie Policy",
      path: "/cookie-policy",
    },
  ]),
];

export default function CookiePolicy() {
  return (
    <>
      <SEO
        title="Cookie Policy"
        description="Learn how Money Mart uses cookies and similar technologies to improve your browsing experience."
        canonical="/cookie-policy"
        structuredData={schemas}
      />
      <LegalLayout
        title="Cookie Policy"
        description="This Cookie Policy explains how Money Mart uses cookies and similar technologies to improve your browsing experience and enhance our services."
        lastUpdated="24 July 2026"
      >
        <h2>1. Introduction</h2>

        <p>
          This Cookie Policy explains how Money Mart ("we", "our", or "us") uses
          cookies and similar technologies when you visit our website.
        </p>

        <p>
          By continuing to browse or use our website, you consent to the use of
          cookies as described in this Cookie Policy, unless you disable them
          through your browser settings.
        </p>

        <br />

        <h2>2. What Are Cookies?</h2>

        <p>
          Cookies are small text files that are stored on your computer,
          smartphone, or other device when you visit a website. Cookies allow
          the website to recognize your device and remember certain information
          about your visit, helping improve functionality and user experience.
        </p>

        <br />

        <h2>3. Why We Use Cookies</h2>

        <p>We use cookies to:</p>

        <ul>
          <li>Ensure the website functions properly.</li>
          <li>Improve website performance.</li>
          <li>Remember user preferences.</li>
          <li>Understand visitor behavior.</li>
          <li>Measure advertising performance.</li>
          <li>Improve loan enquiry and application experience.</li>
          <li>Enhance website security.</li>
        </ul>

        <br />

        <h2>4. Types of Cookies We Use</h2>

        <h3>Essential Cookies</h3>

        <p>
          These cookies are necessary for the operation of our website and
          cannot be disabled through our systems. They enable core functionality
          such as page navigation, security, and form submissions.
        </p>

        <br />

        <h3>Performance & Analytics Cookies</h3>

        <p>
          These cookies help us understand how visitors interact with our
          website by collecting anonymous information such as:
        </p>

        <ul>
          <li>Pages visited.</li>
          <li>Time spent on pages.</li>
          <li>Navigation patterns.</li>
          <li>Website performance metrics.</li>
        </ul>

        <br />

        <h3>Functional Cookies</h3>

        <p>
          Functional cookies remember your preferences and improve your browsing
          experience, such as retaining previously entered information or
          language preferences where applicable.
        </p>

        <br />

        <h3>Marketing & Advertising Cookies</h3>

        <p>
          These cookies help us measure the effectiveness of our advertising
          campaigns and provide more relevant advertisements based on your
          interactions with our website.
        </p>

        <br />

        <h2>5. Third-Party Cookies</h2>

        <p>
          We may allow trusted third-party service providers to place cookies on
          our website for analytics, advertising, customer engagement, and
          website optimization purposes.
        </p>

        <p>These may include services such as:</p>

        <ul>
          <li>Google Analytics</li>
          <li>Google Ads</li>
          <li>Meta Pixel (Facebook Pixel)</li>
          <li>Google Tag Manager</li>
          <li>Other analytics and marketing platforms</li>
        </ul>

        <p>
          These third parties have their own privacy and cookie policies
          governing how they use the information they collect.
        </p>

        <br />

        <h2>6. Information Collected Through Cookies</h2>

        <p>Cookies may collect information including:</p>

        <ul>
          <li>IP Address</li>
          <li>Browser type and version</li>
          <li>Device type</li>
          <li>Operating system</li>
          <li>Visited pages</li>
          <li>Time spent on the website</li>
          <li>Referral source</li>
          <li>UTM campaign parameters</li>
          <li>Clicks and user interactions</li>
        </ul>

        <br />

        <h2>7. Managing Cookies</h2>

        <p>
          Most web browsers allow you to control or disable cookies through
          their settings.
        </p>

        <p>You may:</p>

        <ul>
          <li>Delete existing cookies.</li>
          <li>Block all cookies.</li>
          <li>Block cookies from specific websites.</li>
          <li>Receive notifications before cookies are stored.</li>
        </ul>

        <p>
          Please note that disabling certain cookies may affect the
          functionality and performance of our website.
        </p>

        <br />

        <h2>8. Advertising & Remarketing</h2>

        <p>
          We may use cookies for remarketing campaigns to display advertisements
          on platforms such as Google and Meta after you have visited our
          website.
        </p>

        <p>
          These advertisements are intended to provide relevant information
          about our services and do not influence loan approval decisions.
        </p>

        <br />

        <h2>9. Data Security</h2>

        <p>
          Information collected through cookies is protected using appropriate
          technical and organizational safeguards. However, no method of data
          transmission or electronic storage is completely secure.
        </p>

        <br />

        <h2>10. Changes to this Cookie Policy</h2>

        <p>
          We may update this Cookie Policy periodically to reflect changes in
          our technology, legal obligations, or business practices.
        </p>

        <p>
          The latest version will always be available on this page together with
          the updated revision date.
        </p>

        <br />

        <h2>11. Contact Us</h2>

        <p>
          If you have any questions regarding this Cookie Policy or our use of
          cookies, please contact Money Mart using the contact information
          available on our website.
        </p>
      </LegalLayout>
    </>
  );
}
